export default __webpack_public_path__ + "static/iso-27001-d5726ee8fe5c0feb06246274d7d14fbd.svg";